import { useEffect } from "react";
import { Box, Typography } from "@mui/material";

import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";

import PortalObjectsTable from "../components/PortalObjectsTable.jsx";

/**
 * The full Objekte list. See PortalObjectsTable.jsx for the table itself,
 * including its own search field.
 */
export default function ObjectListPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Übersicht", path: "/" },
      { name: "Objekte", path: "/objekte" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Typography variant="h1" gutterBottom>
        Objekte
      </Typography>
      <PortalObjectsTable />
    </Box>
  );
}
